<template>
  <div class="orders-tab-container">
    <div class="d-flex flex-column flex-lg-row align-center justify-space-between mb-4 gap-4">

      <v-spacer class="d-none d-lg-block"></v-spacer>

    </div>

    <vue-table
      :data="tableData"
      :headers="headers"
      :loading="loading"
      @change="onPagination"
      item-key="id"
    >
      <!-- بخش فیلترها و جستجو -->
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters class="mb-4">
          <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select
              v-model="props.length"
              :items="perPage"
              class="rounded-lg"
              dense
              hide-details
              label="تعداد در هر صفحه"
              outlined
              @change="() => onPagination(props)"
            />
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="4">
            <v-text-field
              v-model="props.search"
              append-icon="mdi-magnify"
              label="جستجو در عنوان یا کد سفارش..."
              outlined
              dense
              hide-details
              clearable
              class="rounded-lg"
              @keyup.enter="() => onPagination(props)"
              @click:clear="() => { props.search = null; onPagination(props); }"
            />
          </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-select
              v-model="props.shipping_type"
              :items="shippingFilterOptions"
              label="نوع ارسال"
              outlined
              dense
              hide-details
              clearable
              class="rounded-lg"
              @change="() => onPagination(props)"
            />
          </v-col>
        </v-row>
      </template>

      <!-- ردیف -->
      <template v-slot:index="{ item }">
        {{ persian(item.index + 1 + (tableData.current_page - 1) * tableData.per_page) }}
      </template>

      <!-- عنوان کالا -->
      <template v-slot:title="{ item }">
        <div class="d-flex flex-column align-start text-right py-2">
          <span class="font-weight-bold text-body-2">{{ item.title || item.product_title || 'بدون عنوان' }}</span>
          <div class="d-flex align-center gap-2 grey--text text-caption mt-1">
            <span v-if="item.order_id">کد سفارش: {{ item.order_id }}</span>
            <span v-if="item.variant_id" class="mx-1">|</span>
            <span v-if="item.variant_id">DKPC-{{ item.variant_id }}</span>
          </div>
        </div>
      </template>

      <!-- تعداد سفارش -->
      <template v-slot:quantity="{ item }">
        <v-chip small color="primary" outlined class="font-weight-bold">
          {{ persian(item.quantity || item.count || 1) }} عدد
        </v-chip>
      </template>

      <!-- تاریخ فروش -->
      <template v-slot:order_created_at="{ item }">
        <div class="d-flex align-center justify-center">
          <v-icon small class="ml-1" color="grey darken-1">mdi-calendar-clock</v-icon>
          <span>
            {{ (item.order_created_at || item.created_at) ? jalalian(item.order_created_at || item.created_at, "datetime") : '---' }}
          </span>
        </div>
      </template>

      <!-- نوع ارسال -->
      <template v-slot:shipping_type="{ item }">
        <v-chip
          small
          label
          text-color="white"
          :color="getShippingColor(item.shipping_type)"
          class="font-weight-bold"
        >
          <v-icon x-small left>{{ getShippingIcon(item.shipping_type) }}</v-icon>
          {{ getShippingLabel(item.shipping_type) }}
        </v-chip>
      </template>
    </vue-table>
  </div>
</template>

<script>
export default {
  name: "OrdersTab",
  data() {
    return {
      loading: false,
      tableProps: {
        page: 1,
        length: 10,
        search: null,
        shipping_type: null,
        dir: "desc",
        column: "id",
      },
      tableData: {
        data: [],
        total: 0,
        current_page: 1,
        per_page: 10,
      },
      shippingFilterOptions: [
        { text: "همه روش‌ها", value: null },
        { text: "مارکت‌پلیس (دیجی‌کالا)", value: "fbd" },
        { text: "ارسال فروشنده", value: "fbs" },
        { text: "۳ ساعته (اکسپرس)", value: "three_hour" },
      ],
      headers: [
        { value: "index", text: "ردیف", sortable: false, align: "center", width: "70px" },
        { value: "title", text: "عنوان کالا", sortable: false, align: "right" },
        { value: "quantity", text: "تعداد سفارش", sortable: false, align: "center", width: "130px" },
        { value: "order_created_at", text: "تاریخ فروش", sortable: false, align: "center", width: "180px" },
        { value: "shipping_type", text: "نوع ارسال", sortable: false, align: "center", width: "170px" },
      ],
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.loading = true;
      try {
        const res = await this.$api.get("/v1/digikala/orders", {
          params: this.tableProps,
        });
        this.tableData = res.data.data || res.data;
      } catch (error) {
        this.$toast.error("خطا در دریافت لیست سفارشات");
      } finally {
        this.loading = false;
      }
    },
    onPagination(e) {
      if (e && typeof e === "object" && !Array.isArray(e)) {
        if ("search" in e && e.search !== this.tableProps.search) {
          e.page = 1;
        }
        this.tableProps = { ...this.tableProps, ...e };
      }
      this.fetch();
    },
    getShippingLabel(type) {
      const map = {
        fbd: "مارکت‌پلیس (دیجی‌کالا)",
        marketplace: "مارکت‌پلیس (دیجی‌کالا)",
        fbs: "ارسال فروشنده",
        seller: "ارسال فروشنده",
        three_hour: "۳ ساعته (اکسپرس)",
        express: "۳ ساعته (اکسپرس)",
      };
      return map[type] || type || "نامشخص";
    },
    getShippingColor(type) {
      const map = {
        fbd: "info",
        marketplace: "info",
        fbs: "deep-purple",
        seller: "deep-purple",
        three_hour: "amber darken-3",
        express: "amber darken-3",
      };
      return map[type] || "grey";
    },
    getShippingIcon(type) {
      const map = {
        fbd: "mdi-truck-fast-outline",
        marketplace: "mdi-truck-fast-outline",
        fbs: "mdi-store-clock-outline",
        seller: "mdi-store-clock-outline",
        three_hour: "mdi-lightning-bolt-outline",
        express: "mdi-lightning-bolt-outline",
      };
      return map[type] || "mdi-truck-delivery-outline";
    },
  },
};
</script>

<style scoped>
.gap-2 { gap: 8px; }
.gap-4 { gap: 16px; }
</style>
